import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentActivity = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'LOGIN':
        return 'LogIn';
      case 'LOGOUT':
        return 'LogOut';
      case 'CREATE':
        return 'Plus';
      case 'READ':
        return 'Eye';
      case 'UPDATE':
        return 'Edit';
      case 'DELETE':
        return 'Trash2';
      case 'PERMISSION_CHECK':
        return 'Shield';
      case 'patient-registered':
        return 'UserPlus';
      case 'appointment-scheduled':
        return 'CalendarPlus';
      case 'prescription-issued':
        return 'FileText';
      case 'lab-result':
        return 'TestTube';
      case 'payment-received':
        return 'CreditCard';
      case 'inventory-updated':
        return 'Package';
      default:
        return 'Activity';
    }
  };

  const getActivityColor = (type, success) => {
    // Show red for failed activities
    if (success === false) return 'text-red-600';
    
    switch (type) {
      case 'LOGIN':
        return 'text-green-600';
      case 'LOGOUT':
        return 'text-orange-600';
      case 'CREATE':
        return 'text-green-600';
      case 'READ':
        return 'text-blue-600';
      case 'UPDATE':
        return 'text-yellow-600';
      case 'DELETE':
        return 'text-red-600';
      case 'PERMISSION_CHECK':
        return 'text-purple-600';
      case 'patient-registered':
        return 'text-green-600';
      case 'appointment-scheduled':
        return 'text-blue-600';
      case 'prescription-issued':
        return 'text-purple-600';
      case 'lab-result':
        return 'text-orange-600';
      case 'payment-received':
        return 'text-emerald-600';
      case 'inventory-updated':
        return 'text-indigo-600';
      default:
        return 'text-gray-600';
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const time = new Date(timestamp);
    const diffInMinutes = Math.floor((now - time) / (1000 * 60));
    
    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return `${Math.floor(diffInMinutes / 1440)}d ago`;
  };

  return (
    <div className="bg-white rounded-xl border-2 border-gray-200 shadow-sm p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-bold text-gray-900">Recent Activity</h3>
        <button className="text-sm text-[#2D869C] hover:text-[#2D869C]/80 font-semibold transition-all">
          View All
        </button>
      </div>
      <div className="space-y-4 max-h-96 overflow-y-auto">
        {activities && activities.length > 0 ? (
          activities.map((activity) => (
            <div key={activity?.id} className="flex items-start space-x-3 p-3 hover:bg-gray-50 rounded-lg transition-all">
              <div className="flex-shrink-0">
                <div className={`w-10 h-10 rounded-full ${activity?.success === false ? 'bg-red-100' : 'bg-gray-100'} flex items-center justify-center ${getActivityColor(activity?.type, activity?.success)}`}>
                  <Icon name={getActivityIcon(activity?.type)} size={18} />
                </div>
              </div>
              
              <div className="flex-1 min-w-0">
                <p className="text-base font-semibold text-gray-900">
                  <span className="font-bold">{activity?.user}</span> {activity?.action}
                  {activity?.target && (
                    <span className="font-bold"> {activity?.target}</span>
                  )}
                  {activity?.success === false && (
                    <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-bold bg-red-100 text-red-800">
                      Failed
                    </span>
                  )}
                </p>
                <div className="flex items-center mt-1 text-sm font-medium text-gray-500">
                  <Icon name="Clock" size={14} className="mr-1" />
                  <span>{formatTimeAgo(activity?.timestamp)}</span>
                  {activity?.location && activity?.location !== 'System' && (
                    <>
                      <span className="mx-2">•</span>
                      <Icon name="MapPin" size={14} className="mr-1" />
                      <span className="truncate max-w-32">{activity?.location}</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-8">
            <Icon name="Activity" size={48} className="mx-auto text-gray-400 mb-3" />
            <p className="text-sm text-muted-foreground">No recent activity found</p>
            <p className="text-xs text-muted-foreground mt-1">Activities will appear here as users interact with the system</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentActivity;